export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// export const STRIPE_PUBLISHABLE_KEY="pk_test_51MA523ADQwJN00E0agkM193pZ9PamAxQpI4I4sWN0EFRtLcizkEzStyVkLLNVUA3OuOyzyZDOCqLW1zGkSLzWDuG00unaxjiYg" 